module.exports = __webpack_public_path__ + "static/img/14002012.9f140e02.png";